import React, { useEffect, useRef } from 'react';

const Projects = () => {
  const projectsRef = useRef(null);
  
  useEffect(() => {
    const currentRef = projectsRef.current;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const projectCards = entry.target.querySelectorAll('.project-card');
          projectCards.forEach((card, index) => {
            setTimeout(() => {
              card.classList.add('animate-fadeInUp');
            }, index * 150);
          });
        }
      });
    }, { threshold: 0.1 });
    
    if (currentRef) {
      observer.observe(currentRef);
    }
    
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  const projects = [
    {
      title: "End-to-End Loan Management System",
      description: "Designed and delivered a digital solution integrating React-based UI with Spring Boot microservices and AWS",
      technologies: ["Java 17","Spring Boot", "React", "Redux", "PostgreSQL", "Redis", "Kafka", "Docker", "Kubernetes", "AWS (EC2, RDS, S3)"],
      impact: "Improved loan approval turnaround time by 50% through Kafka-driven automation and real-time tracking",
      github: "",
      demo: ""
    },
    {
      title: "High-Availability Patient Portal",
      description: "Built a scalable healthcare portal to manage appointments, claims, and prescriptions.",
      technologies: ["Java 11", "Spring Boot", "Angular", "Redis", "Kafka", "Docker", "Kubernetes", "AWS", "ELK Stack"],
      impact: "Achieved 40% faster patient service response times and handled 50K+ concurrent users without downtime",
      github: "",
      demo: ""
    },
    {
      title: "Event-Driven E-Commerce Platform",
      description: "Developed core microservices for high-volume order processing during mega sales events",
      technologies: ["Java 8", "Spring Boot", "Kafka", "Redis", "MySQL", "Docker", "Kubernetes"],
      impact: "Reduced order lookup latency by 40%, ensuring a smooth customer experience during Black Friday",
      github: "#",
      demo: "#"
    },
    {
      title: "Employee Management System(Acadamic Project)",
      description: "Developed a microservices-based backend application using Java, Spring Boot, and PostgreSQL with secured RESTful APIs using Spring Security and JWT. Containerized with Docker and deployed to AWS ECS, with API documentation via Swagger and testing using JUnit and Mockito.",
      technologies: ["Java", "Spring Boot", "PostgreSQL", "Docker", "AWS", "JUnit", "Mockito"],
      impact: "Improved scalability, security, and deployment efficiency through microservices, JWT authentication, automated AWS ECS deployment, and comprehensive API testing.",
      github: "#",
      demo: "#"
    }
  ];

  return (
    <section id="projects" ref={projectsRef} className="py-20 bg-white/95 dark:bg-gray-900/95">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 opacity-1 transform translate-y-10">
          <h2 className="text-3xl md:text-4xl font-bold text-black dark:text-white">Project Portfolio</h2>
          <p className="mt-4 text-xl text-black dark:text-gray-400 max-w-3xl mx-auto font-bold">
            Real-world solutions delivering measurable business impact
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {projects.map((project, index) => (
            <div 
              key={index} 
              className="project-card opacity-0 transform translate-y-10 bg-white dark:bg-gray-900 rounded-xl shadow-lg overflow-hidden border border-gray-200 dark:border-gray-700 hover:shadow-xl transition-all duration-300"
            >
              <div className="p-6">
                <div className="flex justify-between items-start">
                  <h3 className="text-xl font-bold text-black dark:text-white">{project.title}</h3>
                </div>
                
                <p className="mt-3 text-black dark:text-gray-400 font-bold">
                  {project.description}
                </p>
                
                <div className="mt-4 flex flex-wrap gap-2">
                  {project.technologies.map((tech, idx) => (
                    <span 
                      key={idx} 
                      className="px-3 py-1 bg-gray-100 dark:bg-gray-800 text-black dark:text-gray-200 rounded-full text-sm font-bold"
                    >
                      {tech}
                    </span>
                  ))}
                </div>
                
                <div className="mt-5 p-3 bg-indigo-50 dark:bg-indigo-900/30 rounded-lg">
                  <span className="font-bold text-indigo-700 dark:text-indigo-300">Business Impact:</span>
                  <span className="ml-2 text-black dark:text-gray-300 font-bold">{project.impact}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;